import { Button, Modal } from "antd";
import styles from "./styles/Referral.module.css";
import { CheckCircleFilled, CloseOutlined } from "@ant-design/icons";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { useState } from "react";
import { useEffect } from "react";

function PendingModal({ open, onCancel }) {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  return (
    <Modal
      closeIcon={
        <CloseOutlined
          onClick={(e) => {
            onCancel();
          }}
        />
      }
      footer={[
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Button onClick={onCancel} className={styles.pendingCloseButton}>
            {dublicatedcontent.dublicatedText152}
          </Button>
        </div>,
      ]}
      open={open}
      className={styles.pendingModal}
    >
      <div
        className={styles.pendingModalContainer}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "5px",
        }}
      >
        <CheckCircleFilled
          style={{
            color: "#419f23",
          }}
        />
        <h3>{dublicatedcontent.dublicatedText153}</h3>
      </div>
      <div
        className={styles.pendingModalContent}
        style={{
          textAlign: "center",
        }}
      >
        <p>{dublicatedcontent.dublicatedText154}</p>
      </div>
    </Modal>
  );
}

export default PendingModal;
